/**
 * Constants for mapping group identification
 */
export const MAPPING_GROUP = '_mapping_group';
export const XMLMAPPING_ID = '_xmlmapping';
/**
 * MappingGroup module
 * @private
 */
export class MappingGroup {
    /**
     * Constructor for MappingGroup class
     * @param {DocumentEditorContainer} container - DocumentEditorContainer instance
     */
    constructor(container) {
        this.container = container;
        this.ribbonId = this.container.element.id + '_ribbon';
    }
    /**
     * Get the DocumentEditor instance
     * @returns {DocumentEditor} The DocumentEditor instance
     */
    get documentEditor() {
        return this.container.documentEditor;
    }
    /**
     * Get the Mapping group model
     * @returns {RibbonGroupModel} The Mapping group model
     */
    getGroupModel() {
        const locale = this.container.localObj;
        const id = this.ribbonId + MAPPING_GROUP;
        return {
            id: id,
            header: locale.getConstant('Mapping'),
            orientation: 'Row',
            enableGroupOverflow: true,
            overflowHeader: locale.getConstant('Mapping'),
            collections: [
                {
                    items: [
                        this.getXmlMappingButtonModel()
                    ]
                }
            ]
        };
    }
    /**
     * Get the XML Mapping button model
     * @returns {RibbonItemModel} The XML Mapping button model
     */
    getXmlMappingButtonModel() {
        const locale = this.container.localObj;
        const id = this.ribbonId + MAPPING_GROUP;
        return {
            type: 'Button',
            id: id + XMLMAPPING_ID,
            buttonSettings: {
                iconCss: 'e-icons e-de-ctnr-xml-mapping',
                content: locale.getConstant('XML Mapping Pane'),
                clicked: this.onXmlMappingClick.bind(this)
            },
            ribbonTooltipSettings: {
                content: locale.getConstant('XML Mapping Pane')
            }
        };
    }
    /**
     * Handle XML Mapping button click
     * @returns {void}
     */
    onXmlMappingClick() {
        if (!this.documentEditor.isXmlPaneTool) {
            this.documentEditor.showXmlPane();
        }
        this.container.statusBar.toggleWebLayout();
        setTimeout(() => {
            this.documentEditor.focusIn();
        }, 30);
    }
    /**
     * Update UI based on current selection
     * @returns {void}
     * @private
     */
    updateSelection() {
        // Update UI state based on current selection
        const isReadOnly = this.documentEditor.isReadOnly;
        const isDocumentProtected = this.documentEditor.documentHelper.isDocumentProtected;
        // Disable XML mapping in read-only mode or protected document
        const enableXmlMapping = !isReadOnly && !isDocumentProtected;
        // Implementation to enable/disable XML mapping button
        const xmlMappingElement = document.getElementById(this.ribbonId + MAPPING_GROUP + XMLMAPPING_ID);
        if (xmlMappingElement) {
            xmlMappingElement.classList.toggle('e-disabled', !enableXmlMapping);
        }
    }
    /**
     * Destroy the MappingGroup instance
     * @returns {void}
     * @private
     */
    destroy() {
        // Clear all references
        this.container = undefined;
        this.ribbonId = undefined;
    }
}
